// extracted by mini-css-extract-plugin
export default {"content-title":"gFibPqAvbdOapOptORa0vw==","payment-methods-list":"smjQns41qHDpw0e+B7yD6Q=="};